import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { IoInformationCircleOutline } from "react-icons/io5";

const CustomToolTip = ({ content }) => {
    return <OverlayTrigger placement='top' overlay={<Tooltip>{content}</Tooltip>}>
        <IoInformationCircleOutline size={18} />
    </OverlayTrigger>
}

export default CustomToolTip;